import { RouteRecordRaw } from 'vue-router'

const PARENT_VIEW = () => import('@/layout/routerView.vue')

const routes: RouteRecordRaw[] = [
  {
    path: 'zdev',
    name: 'zdev',
    component: PARENT_VIEW,
    redirect: '/zdev/modules',
    meta: { title: '开发工具', icon: 'svg:menu-xdev', order: 120 },
    children: [
      { path: 'modules', name: 'zdev_modules', component: () => import('./Modules/index.vue'), meta: { title: '模块管理' } },
      { path: 'generate', name: 'zdev_generate', component: () => import('@/views/ZDev/Generate/index.vue'), meta: { title: '代码生成', hidden: true } },
      { path: 'generator', name: 'zdev_generator', component: () => import('@/views/ZDev/Generator/index.vue'), meta: { title: '生成器', hidden: true } },
      { path: 'schema', name: 'zdev_schema', component: () => import('@/views/ZDev/Schema/index.vue'), meta: { title: 'Schema管理', hidden: true } }
    ]
  }
]

export default routes
